import { render, staticRenderFns } from "./AdvancesTo.vue?vue&type=template&id=bc75e968&scoped=true&"
import script from "./AdvancesTo.vue?vue&type=script&lang=js&"
export * from "./AdvancesTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc75e968",
  null
  
)

export default component.exports